import React, { useEffect }             from 'react';
import { useDispatch, useSelector }     from 'react-redux'
import classnames                       from 'classnames';

import InstantQuote      from 'pu-react/components/InstantQuoteFC';
import Quantities        from 'pu-react/components/Quantities';
import NumberLayer       from 'pu-react/components/NumberLayer';
import BoardSize         from 'pu-react/components/BoardSize';
import MaterialType      from 'pu-react/components/MaterialType';
import MaterialThickness from 'pu-react/components/MaterialThickness';
import FinishPlating     from 'pu-react/components/FinishPlating';
import CopperWeight      from 'pu-react/components/CopperWeight';
import Soldermask        from 'pu-react/components/Soldermask';
import Silkscreen        from 'pu-react/components/Silkscreen';
import ViaFill           from 'pu-react/components/ViaFill';
import { START }         from 'pu-data/QuoteSteps';

import SectionPanelized     from 'pu-react/components/SectionPanelizedITV';
import Counterbore          from 'pu-react/components/Counterbore';
import BlindSlot            from 'pu-react/components/BlindSlot';
import Countersink          from 'pu-react/components/Countersink';
import ControlledDielectric from 'pu-react/components/ControlledDielectric';
import ControlledImpedance  from 'pu-react/components/ControlledImpedance';
import Castellation         from 'pu-react/components/Castellation';
import BlindBuriedHole      from 'pu-react/components/BlindBuriedHoleCheckbox';

import SpecialInstruction  from 'pu-react/components/SpecialInstruction';
import RequiredInformation from 'pu-react/components/RequiredInformation';

import SupplierSelected   from 'pu-react/components/SupplierSelected';
import ProductQuoteNumber from 'pu-react/components/ProductQuoteNumber';
import ParametersChanged  from 'pu-react/components/ParametersChanged';
import RowSelected        from 'pu-react/components/RowSelected';
import ColumnSelected     from 'pu-react/components/ColumnSelected';
import VendorSelected     from 'pu-react/components/VendorSelected';
import QuoteConfigKey     from 'pu-react/components/QuoteConfigKey';
import EmailHidden     from 'pu-react/components/EmailHidden';

import CustomQuoteRequestModal from 'pu-react/components/CustomQuoteRequestModalFC';

// import InstantQuote from './form/InstantQuote';
import CombinedSelected from './form/CombinedSelected';
import MinTraceSpace    from './form/MinTraceSpace';
import SmallestHoleSize from './form/SmallestHoleSize';

import { selectFabricationDataForParameters } from '../selector/selectors';

import {
  materialType,
  numberLayer,
  materialThickness,
  finishPlating,
  cooperInner,
  cooperOuter
} from '../data/SelectOptions';

import { 
  validator,
  doQuote,
  doEmailQuoteRequest,
  changeParameter,
  updateCustomQuoteRequest,
  updateValidatorFlag,
} from '../fabricationSlice';

import { isParameterNameQtyValid } from 'pu-utils/validate';
import { changeGlobalParameter } from 'product_tabs/actions';

export default () => {
  const dispatch = useDispatch();
  const {
    customQuoteRequest,
    needCustomQuote,
    parameters,
    validatorFlag,
  } = useSelector(selectFabricationDataForParameters)

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }))
    if (isParameterNameQtyValid(name)) dispatch(changeGlobalParameter({ name: `fabrication_${name}`, value }));
  }

  const onQuoteRequest = () => {
    if (!validator.allValid()){
      validator.showMessages();
      dispatch(updateValidatorFlag())
      return;
    }

    if(needCustomQuote){
      dispatch(updateCustomQuoteRequest(true));
      return;
    }

    dispatch(doQuote());    
  }

  const props = {
    parameters,
    onChangeParameter,
  }

  const onCustomQuoteSend = () => {
    dispatch(updateCustomQuoteRequest(false));
    dispatch(doEmailQuoteRequest());
  }

  const onCustomQuoteCancel = () => {
    dispatch(updateCustomQuoteRequest(false));
  }

  /*
  useEffect(() => {
    const { onChangeParameter } = props;
    if (Spree.quick_quote) {
      _.each(Spree.quick_quote, (value, key) => {
        onChangeParameter(key, value);
      });
      // TODO: improve other way raise quote after change all parameters
      setTimeout(() => {
        jQuery('form .instant-quote-top .btn-main-action').click();
      }, 500);
    }
  }, [])
  */

  return (
    <div className="pcb-form-section">
      <div className="row">        
        <div className="col-md-6 instant-quote-top">
          <InstantQuote {...props} onQuoteRequest={onQuoteRequest}/>
        </div>
        <div className='col-md-6'/>
      </div>

      <div className="row">
        <div className="col-md-12">
          <Quantities
            {...props}
            errorMessage={validator.message('Quantity', parameters.quantities, 'group_required|group_numeric|group_min:1,num')} />
        </div>
        <div className="col-6 col-lg-12 col-xl-6">
          <NumberLayer {...props} options={numberLayer} />
        </div>
        <div className="col-6 col-lg-12 col-xl-6">
          <MaterialThickness {...props} options={materialThickness} />
        </div>
        <div className="col-12">
          <BoardSize {...props} template="two-cols" boardSizerequired={true}
            errorMessageLength={validator.message('Board Length', parameters.board_length, 'required|numeric|min:0.1,num|max:20,num')}
            errorMessageWidth={validator.message('Board Width', parameters.board_width, 'required|numeric|min:0.1,num|max:33,num')} />
        </div>
        <div className="col-md-12">
          <div id="error_board_size" />
        </div>

        <div className="col-md-12">
          <SectionPanelized {...props} />
        </div>

        <div className="col-md-6">
          <MaterialType {...props} options={materialType} />
        </div>

        <div className="col-md-6">
          <FinishPlating {...props} options={finishPlating} />
        </div>
        <div className="col-md-12">
          <CopperWeight {...props} innerOptions={cooperInner} outerOptions={cooperOuter} template="two-cols" />
        </div>
        <div className="col-md-12">
          <Soldermask {...props} />
        </div>
        <div className="col-md-12">
          <Silkscreen {...props} />
        </div>
        <div className="col-md-6">
          <ViaFill {...props} />
        </div>
        <div className="w-100" />
        <div className="col-md-6 col-lg-12 col-xl-6">
          <ControlledImpedance {...props} />
        </div>
        <div className="col-md-6 col-lg-12 col-xl-6">
          <Castellation {...props} />
        </div>
        <div className="col-md-6 col-lg-12 col-xl-6">
          <Countersink {...props} />
        </div>
        <div className="col-md-6 col-lg-12 col-xl-6">
          <Counterbore {...props} />
        </div>
        <div className="col-md-6 col-lg-12 col-xl-6">
          <BlindSlot {...props} />
        </div>


        <div className="col-12 py-3">
          <div className="card">
            <div className="card-header">
              CUSTOM SPECS (CANNOT QUOTE ONLINE)
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 col-lg-12 col-xl-6">
                  <BlindBuriedHole {...props} label="Blind & Buried Vias" tooltip={null} />
                </div>
                <div className="col-md-6 col-lg-12 col-xl-6">
                  <ControlledDielectric {...props} tooltip={null} />
                </div>
                <div className="col-md-6 col-lg-12 col-xl-6">
                  <MinTraceSpace {...props} />
                </div>
                <div className="col-md-6 col-lg-12 col-xl-6">
                  <SmallestHoleSize {...props} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <SpecialInstruction {...props} />
        </div>

        <div>
          <SupplierSelected {...props} />
          <ProductQuoteNumber {...props} />
          <ParametersChanged {...props} />
          <CombinedSelected {...props} />
          <RowSelected {...props} />
          <ColumnSelected {...props} />
          <VendorSelected {...props} />
          <QuoteConfigKey {...props} />
          <EmailHidden {...props} />
          <input type="hidden" name="quantity" value="1" />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <RequiredInformation />
        </div>
      </div>
      <CustomQuoteRequestModal {...props} 
        customQuoteRequest={customQuoteRequest}
        onCustomQuoteSend={onCustomQuoteSend}
        onCustomQuoteCancel={onCustomQuoteCancel}/>
    </div>
  );
};
